import type { TimePoint } from '@vedalib/editor/lib/elements'
import React from 'react'

import { TooltipCourse } from 'components/Editor/EditorElements/courseKit/DropDownCourse'
import DropdownMenuCourse from 'components/Editor/EditorElements/courseKit/DropdownMenuCourse/DropdownMenuCourse'
import { seekTo } from 'components/MediaPlayer/store/actions'
import type { Actions } from 'components/MediaPlayer/store/types'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'

import * as s from '../Controls.module.scss'
import { MediaControlType } from '../types'
import { useMediaT } from '../useMediaT'
import Item from './Item'

interface ITimePointsProps {
  dispatch: React.Dispatch<Actions>
  timePoints: TimePoint[]
  container: () => HTMLElement
  disableSeeking?: boolean
  maxPlayedSeconds?: number
  isCourse?: boolean
}

const TimePoints: React.FC<ITimePointsProps> = ({
  timePoints,
  dispatch,
  container,
  disableSeeking,
  maxPlayedSeconds,
  isCourse = false,
}) => {
  const tt = useMediaT(isCourse)
  return (
    <TooltipCourse overlay={tt('elements.media.timePoints')} placement='top'>
      <div>
        <DropdownMenuCourse
          ariaLabel='Timecode'
          buttonProps={{ 'data-player-control': MediaControlType.TimePoints }}
          container={container()}
          onClick={(option) => {
            dispatch(seekTo(option.value))
          }}
          options={timePoints.map(({ time, title }) => ({
            id: time,
            value: time,
            label: (
              <Item
                disabled={disableSeeking && time > (maxPlayedSeconds ?? 0)}
                time={time}
                title={title}
              />
            ),
          }))}
        >
          <div className={s.buttons}>
            <Icon name='builderTimeline' size={KitSize.S} />
          </div>
        </DropdownMenuCourse>
      </div>
    </TooltipCourse>
  )
}

export default TimePoints
